import { render, staticRenderFns } from "./BusinessHours.vue?vue&type=template&id=b6144c26&scoped=true&lang=pug&"
import script from "./BusinessHours.vue?vue&type=script&lang=js&"
export * from "./BusinessHours.vue?vue&type=script&lang=js&"
import style0 from "./BusinessHours.vue?vue&type=style&index=0&id=b6144c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6144c26",
  null
  
)

/* custom blocks */
import block0 from "./BusinessHours.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VCard,VCol,VDialog,VDivider,VRow,VTab,VTabs,VTextField,VTimePicker})
